import {EntityWithIdAndDescription} from "./baseEntities";

export enum Modules {
    WorkFlow = 6,
    SolicitationAdministration = 7,
    ReclaimAdmin = 8,
    Reports = 9,
    Clients = 10,
    GeneralAdministration = 11,
    Home = 12,
    Activities = 13,
    AutomaticProcesses = 14,
    SolicitationView = 15,
    SolicitationOnboarding = 16
}

export enum BankFields {
    CountryCode = 'sinCodPais'
}

export interface Bank extends EntityWithIdAndDescription {
    [BankFields.CountryCode]: number;
}

export enum Origins {
    WAG = 1,
    WAGBanks = 2,
    Condor = 3,
    AppWeb = 4,
    Onboarding = 5
}

export enum Channels {
    WebPyme = 1,
    Banco = 2,
    WorkFlow = 3,
    Onboarding = 4
}

export enum MaritalStates {
    Soltero = 1,
    Casado = 2,
    Divorciado = 3,
    Separado = 4,
    Viudo = 5,
    Convivientes = 6
}